module.exports = __webpack_public_path__ + "img/fr.8b296b78.svg";